import * as React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorIconWrapper: {
        textAlign: "center",
        marginTop: "75px"
    },
    errorIcon: {
      width: "300px",
    }
  })
);

const NotAuthorized: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  
  return (
    <div className={classes.errorIconWrapper}>
      <img
        src="/public/img/error.svg"
        alt="Fehler auf Seite"
        className={classes.errorIcon}
      />
      <Typography variant="h4"><strong>403</strong> - {t("notAuthorized.title")}</Typography>
      <Typography variant="body1">{t("notAuthorized.subtitle")}</Typography>
      <Box marginTop={2} />
      <Button variant="contained" color="primary" component={RouterLink} to="/">{t("notAuthorized.backToHome")}</Button>
    </div>
  );
};

export default NotAuthorized;
